import React, { createContext, useState, useContext } from 'react';

export const ALL_REVIEW_TITLES_LABEL = 'All Reviews';

const FilterContext = createContext();

export const FilterProvider = ({ children }) => {
    // For MentorReview
    const [mentorReviewState, setMentorReviewState] = useState({
        selection: null,
        showTable: null,
        statusFilter: 'all',
        learnerFilter: 'all',
        selectedLearnerId: null,
        reviewNameFilter: 'all',
        sortBy: 'latest',
        currentPage: 1,
        rowsPerPage: 10,
        learnerInput: 'All Learners',
        reviewNameInput: 'All Reviews',
        fromDate: '',
        toDate: '',
        reviewsData: [],
        totalRecords: 0,
        stats: { totalLearners: 0, totalReviews: 0, completedReviews: 0, verificationPending: 0, reviewPending: undefined, evaluationPending: undefined, evaluationFailed: undefined, lcPending: undefined },
        options: { apiReviewNames: [], coeLearnersList: [], coes: [], labNames: [], labTypes: [], semesters: [] },
        hasFetched: false
    });

    // For LearnerPractices
    const [learnerPracticesState, setLearnerPracticesState] = useState({
        selection: null,
        showTable: null,
        statusFilter: 'all',
        learnerFilter: 'all',
        selectedLearnerId: null,
        PracticeNameFilter: 'all',
        sortBy: 'latest',
        currentPage: 1,
        rowsPerPage: 10,
        learnerInput: 'All Learners',
        PracticeNameInput: 'All Practices',
        fromDate: '',
        toDate: '',
        PracticesData: [],
        totalRecords: 0,
        stats: { totalLearners: 0, totalPractices: 0, completedPractices: 0, pendingPractices: 0, evaluationPending: undefined, evaluationFailed: undefined },
        options: { apiPracticeNames: [], coeLearnersList: [], coes: [], labNames: [], labTypes: [], semesters: [] },
        hasFetched: false
    });

    // Admin Attendance Report state
    const [adminAttendanceState, setAdminAttendanceState] = useState({
        selection: { coe: "", labType: "", attendanceName: "", timeSlot: "", fromDate: "", toDate: "", semester: "" },
        searchText: "",
        data: [],
        showTable: false,
        page: 0,
        rowsPerPage: 50,
        options: { allCOE: [], labTypes: [], attendanceOptions: [], timeSlots: [], semesters: [] },
        hasFetched: false
    });

    // Admin Daily Practice Report state
    const [adminDailyPracticeState, setAdminDailyPracticeState] = useState({
        selection: { lab: '', coe: '', makerPlan: '', makerModule: '', labType: "" },
        tableData: [],
        showTable: false,
        page: 0,
        rowsPerPage: 50,
        options: { coes: [], labNames: [], makerPlanOptions: [], moduleOptions: [], labTypeOptions: [] },
        hasFetched: false
    });

    // Lab Component state (Admin Lab Practice)
    const [labComponentState, setLabComponentState] = useState({
        selectedFilters: { selectedCOE: '', labType: '', currentSemester: '', enrolmentYear: '' },
        isViewTriggered: false,
        rowData: [],
        options: { allCOE: [], labTypes: [], semesters: [], enrolmentYearOptions: [] },
        hasFetched: false
    });

    // CheckInOut Report state
    const [checkInOutReportState, setCheckInOutReportState] = useState({
        selection: { coe: "", labType: "", attendanceName: "", timeSlot: "", fromDate: "", toDate: "" },
        data: [],
        showTable: false,
        page: 0,
        rowsPerPage: 50,
        options: { allCOE: [], labTypes: [], attendanceOptions: [], timeSlots: [] },
        hasFetched: false
    });

    // Report Viewer Learner Review state
    const [reportViewerReviewState, setReportViewerReviewState] = useState({
        semester: '',
        reviewName: 'all',
        reviewNameInput: ALL_REVIEW_TITLES_LABEL,
        sortBy: 'latest',
        currentPage: 1,
        rowsPerPage: 10,
        cardsPage: 1,
        cardsPerPage: 10,
        reviewsData: [],
        totalRecords: 0,
        showTable: true,
        viewMode: 'reviews',
        selectedReview: null,
        selectedReviewId: null,
        selectedLab: null,
        selectedLabId: null,
        learnerSubmissions: [],
        apiLabWiseData: [],
        reviewSearchText: '',
        labSearchText: '',
        lastUpdated: null,
        stats: {
            totalLearners: 0,
            totalLearnersGivenReview: undefined,
            totalConductedReviews: undefined,
            totalReviews: 0,
            averageReviews: 0,
            averageScore: 0,
            maxScore: 0,
            maxReviews: 0,
        },
        options: { semesters: [], apiReviewNames: [] },
        hasFetched: false
    });

    // Report Viewer Learner Attendance state
    const [reportViewerAttendanceState, setReportViewerAttendanceState] = useState({
        selection: { labType: "", attendanceName: "", timeSlot: "", fromDate: "", toDate: "", semester: "" },
        searchText: "",
        data: [],
        statistics: null,
        showTable: false,
        page: 0,
        rowsPerPage: 50,
        lastRefreshed: null,
        options: { labTypes: [], attendanceOptions: [], timeSlots: [], semesters: [] },
        hasFetched: false
    });

    const clearAllFilters = () => {
        setMentorReviewState({
            selection: null, showTable: null, statusFilter: 'all', learnerFilter: 'all',
            selectedLearnerId: null, reviewNameFilter: 'all', sortBy: 'latest', currentPage: 1,
            rowsPerPage: 10, learnerInput: 'All Learners', reviewNameInput: 'All Reviews',
            fromDate: '', toDate: '', reviewsData: [], totalRecords: 0,
            stats: { totalLearners: 0, totalReviews: 0, completedReviews: 0, verificationPending: 0, reviewPending: undefined, evaluationPending: undefined, evaluationFailed: undefined, lcPending: undefined },
            options: { apiReviewNames: [], coeLearnersList: [], coes: [], labNames: [], labTypes: [], semesters: [] },
            hasFetched: false
        });
        setLearnerPracticesState({
            selection: null, showTable: null, statusFilter: 'all', learnerFilter: 'all',
            selectedLearnerId: null, PracticeNameFilter: 'all', sortBy: 'latest', currentPage: 1,
            rowsPerPage: 10, learnerInput: 'All Learners', PracticeNameInput: 'All Practices',
            fromDate: '', toDate: '', PracticesData: [], totalRecords: 0,
            stats: { totalLearners: 0, totalPractices: 0, completedPractices: 0, pendingPractices: 0, evaluationPending: undefined, evaluationFailed: undefined },
            options: { apiPracticeNames: [], coeLearnersList: [], coes: [], labNames: [], labTypes: [], semesters: [] },
            hasFetched: false
        });
        setAdminAttendanceState({
            selection: { coe: "", labType: "", attendanceName: "", timeSlot: "", fromDate: "", toDate: "", semester: "" },
            searchText: "", data: [], showTable: false, page: 0, rowsPerPage: 50,
            options: { allCOE: [], labTypes: [], attendanceOptions: [], timeSlots: [], semesters: [] },
            hasFetched: false
        });
        setAdminDailyPracticeState({
            selection: { lab: '', coe: '', makerPlan: '', makerModule: '', labType: "" },
            tableData: [], showTable: false, page: 0, rowsPerPage: 50,
            options: { coes: [], labNames: [], makerPlanOptions: [], moduleOptions: [], labTypeOptions: [] },
            hasFetched: false
        });
        setLabComponentState({
            selectedFilters: { selectedCOE: '', labType: '', currentSemester: '', enrolmentYear: '' },
            isViewTriggered: false, rowData: [],
            options: { allCOE: [], labTypes: [], semesters: [], enrolmentYearOptions: [] },
            hasFetched: false
        });
        setCheckInOutReportState({
            selection: { coe: "", labType: "", attendanceName: "", timeSlot: "", fromDate: "", toDate: "" },
            data: [], showTable: false, page: 0, rowsPerPage: 50,
            options: { allCOE: [], labTypes: [], attendanceOptions: [], timeSlots: [] },
            hasFetched: false
        });
        setReportViewerReviewState({
            semester: '', reviewName: 'all', reviewNameInput: ALL_REVIEW_TITLES_LABEL, sortBy: 'latest', currentPage: 1,
            rowsPerPage: 10, cardsPage: 1, cardsPerPage: 10, reviewsData: [], totalRecords: 0, showTable: true, viewMode: 'reviews',
            selectedReview: null, selectedReviewId: null, selectedLab: null, selectedLabId: null,
            learnerSubmissions: [], apiLabWiseData: [], reviewSearchText: '', labSearchText: '', lastUpdated: null,
            stats: {
                totalLearners: 0,
                totalLearnersGivenReview: undefined,
                totalConductedReviews: undefined,
                totalReviews: 0,
                averageReviews: 0,
                averageScore: 0,
                maxScore: 0,
                maxReviews: 0,
            },
            options: { semesters: [], apiReviewNames: [] },
            hasFetched: false
        });
        setReportViewerAttendanceState({
            selection: { labType: "", attendanceName: "", timeSlot: "", fromDate: "", toDate: "", semester: "" },
            searchText: "", data: [], statistics: null, showTable: false, page: 0, rowsPerPage: 50, lastRefreshed: null,
            options: { labTypes: [], attendanceOptions: [], timeSlots: [], semesters: [] },
            hasFetched: false
        });
    };

    return (
        <FilterContext.Provider value={{
            mentorReviewState, setMentorReviewState,
            learnerPracticesState, setLearnerPracticesState,
            adminAttendanceState, setAdminAttendanceState,
            adminDailyPracticeState, setAdminDailyPracticeState,
            labComponentState, setLabComponentState,
            checkInOutReportState, setCheckInOutReportState,
            reportViewerReviewState, setReportViewerReviewState,
            reportViewerAttendanceState, setReportViewerAttendanceState,
            clearAllFilters
        }}>
            {children}
        </FilterContext.Provider>
    );
};

export const useFilters = () => useContext(FilterContext);
